import {inject, Pipe, PipeTransform, SecurityContext, VERSION} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'nl2br',
    standalone: false
})
export class Nl2BrPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);

    transform(value: string, sanitizeBeforehand?: boolean): string {
        if (typeof value !== 'string') {
            return value;
        }
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        let result: any;
        const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');

        if (!VERSION || VERSION.major === '2') {
            result = this.sanitizer.bypassSecurityTrustHtml(textParsed);
        } else if (sanitizeBeforehand) {
            result = this.sanitizer.sanitize(SecurityContext.HTML, textParsed);
        } else {
            result = textParsed;
        }

        return result;
    }

}
